






























import Vue from "vue";
import * as moment from "moment";

// Model
import { GetInstallationServiceModeHistoryCommand } from "@/model/communication/device/GetInstallationServiceModeHistoryCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { InstallationServiceModeSwitching } from "@/model/data/serviceMode/InstallationServiceModeSwitching";
import { ServiceModeStatusEnum } from "@/model/data/serviceMode/ServiceModeStatusEnum";

export default Vue.extend({
    data() {
        return {
            loading: false,
            dialog: false,
            installationServiceModeHistory: [],
            selectablePeriods: ["M3", "M6", "Y1", "YTD"],
            dates: [],
        };
    },
    computed: {
        dateRangeText() {
            return this.dates.join(" ~ ");
        },
        date1() {
            if (this.dates.length == 2) {
                const date1 = new Date(this.dates[0]);
                const date2 = new Date(this.dates[1]);
                if (date1 <= date2) return date1;
                else return date2;
            } else return null;
        },
        date2() {
            if (this.dates.length == 2) {
                const date1 = new Date(this.dates[0]);
                const date2 = new Date(this.dates[1]);
                if (date1 <= date2) return date2;
                else return date1;
            } else return null;
        },
        installationServiceModeHistoryFilteredByDates() {
            if (this.dates.length == 2) {
                return this.installationServiceModeHistory.filter((s) => new Date(s.timestamp) >= this.date1 && new Date(s.timestamp) <= this.date2);
            } else return this.installationServiceModeHistory;
        },
        uptimePercentage() {
            if (this.downtimeInHours != null && this.downtimeInHours > 0) {
                let totalHours: number = Math.abs(new Date(this.date2).getTime() - new Date(this.date1).getTime()) / (1000 * 60 * 60);
                return (100 - (this.downtimeInHours * 100) / totalHours).toFixed(2);
            } else return 100;
        },
        downtimeInHours() {
            let result = 0;
            let currentStartTime: Date = null;
            for (let element of this.installationServiceModeHistoryFilteredByDates) {
                if (element.serviceModeStatus == ServiceModeStatusEnum.Enabled) {
                    if (currentStartTime == null) currentStartTime = element.timestamp;
                } else if (currentStartTime != null) {
                    let start = new Date(currentStartTime).getTime();
                    let end = new Date(element.timestamp).getTime();
                    result = result + Math.abs(end - start);
                    currentStartTime = null;
                }
            }
            return (result / (1000 * 60 * 60)).toFixed(2);
        },
        installationServiceModeHistoryForChart() {
            if (this.installationServiceModeHistoryFilteredByDates.length > 0) {
                let result: InstallationServiceModeSwitching[] = [];
                let startValue: InstallationServiceModeSwitching = new InstallationServiceModeSwitching();
                startValue.timestamp = this.date1 ? this.date1.toISOString().split(".")[0] : this.date1;
                result.push(startValue);
                this.installationServiceModeHistoryFilteredByDates.forEach((ss) => {
                    result.push(ss);
                });
                let endValue: InstallationServiceModeSwitching = new InstallationServiceModeSwitching();
                endValue.timestamp = this.date2 ? this.date2.toISOString().split(".")[0] : this.date2;
                endValue.serviceModeStatus = this.installationServiceModeHistoryFilteredByDates[this.installationServiceModeHistoryFilteredByDates.length - 1].serviceModeStatus;
                result.push(endValue);
                return result;
            } else return [];
        },
        datasets() {
            return [
                {
                    name: "Dataset",
                    data: this.installationServiceModeHistoryForChart.map((a) => -a.serviceModeStatus),
                },
            ];
        },
        chart() {
            let labels = this.installationServiceModeHistoryForChart.map((a) => a.timestamp);
            return {
                options: {
                    chart: {
                        type: "line",
                        height: 350,
                        zoom: {
                            type: "x",
                            enabled: false,
                        },
                    },
                    stroke: {
                        curve: "stepline",
                    },
                    labels,
                    dataLabels: {
                        enabled: false,
                    },
                    markers: {
                        hover: {
                            sizeOffset: 4,
                        },
                    },
                    xaxis: {
                        type: "datetime",
                    },
                    yaxis: {
                        tickAmount: 2,
                        labels: {
                            formatter: this.yLabelsMapping,
                        },
                    },
                },
                series: this.datasets,
            };
        },
    },
    props: ["installationName"],
    watch: {
        installationName(newValue) {
            // comando per richiedere lo storico per questa installazione
            this.refresh(newValue);
        },
    },
    methods: {
        selectPeriod(selectedPeriod: string) {
            let monthToRemove = 0;
            switch (selectedPeriod) {
                case "M3":
                    monthToRemove = 3;
                    break;
                case "M6":
                    monthToRemove = 6;
                    break;
                case "Y1":
                    monthToRemove = 12;
                    break;
                default:
                    break;
            }

            let endDate = new Date();
            let startDate = new Date(new Date().setMonth(endDate.getMonth() - monthToRemove));
            if (selectedPeriod == "YTD") startDate = new Date(endDate.getFullYear(), 0, 1);

            let date1String = moment(startDate).format("YYYY-MM-DD");
            let date2String = moment(endDate).format("YYYY-MM-DD");
            this.dates = [date1String, date2String];
        },
        yLabelsMapping(value) {
            switch (value) {
                case ServiceModeStatusEnum.Disabled:
                    return this.$t("common.uptime");
                case -ServiceModeStatusEnum.Enabled:
                    return this.$t("common.downtime");
                default:
                    return "";
            }
        },
        refresh(installationName: string) {
            this.getInstallationServiceModeHistory(installationName);
            let now = new Date();
            let date1 = new Date(new Date(now).setDate(now.getDate() - 15));
            let date1String = moment(date1).format("YYYY-MM-DD");
            let date2String = moment(now).format("YYYY-MM-DD");
            this.dates = [date1String, date2String];
        },

        async getInstallationServiceModeHistory(installationName: string) {
            if (!this.loading) {
                try {
                    this.loading = true;
                    let res = await new GetInstallationServiceModeHistoryCommand(installationName).execute();
                    this.loading = false;

                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.installationServiceModeHistory = res.installationServiceModeHistory;
                    } else console.error("Error executing GetInstallationServiceModeHistoryCommand");
                } catch (e) {
                    console.error("Error executing GetInstallationServiceModeHistoryCommand");
                    this.loading = false;
                }
            }
        },
        showDialog() {
            this.dialog = true;
            this.$refs.chart.render();
        },
    },
    mounted() {
        this.refresh(this.installationName);
        if (this.$refs.chart) this.$refs.chart.render();
    },
});
